"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import { colorSchemes, themeColors } from "./theme";

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState(() => {
		if (typeof window !== "undefined") {
			return localStorage.getItem("neuquen-theme") || "light";
		}
		return "light";
	});

	const [colorScheme, setColorScheme] = useState(() => {
		if (typeof window !== "undefined") {
			return localStorage.getItem("neuquen-color-scheme") || "blue";
		}
		return "blue";
	});

	useEffect(() => {
		if (typeof window !== "undefined") {
			const root = document.documentElement;
			const body = document.body;
			const metaThemeColor = document.querySelector('meta[name="theme-color"]');
			if (theme === "dark") {
				root.classList.add("dark");
				body.style.backgroundColor = "#09090b";
				if (metaThemeColor) metaThemeColor.setAttribute("content", "#09090b");
			} else {
				root.classList.remove("dark");
				body.style.backgroundColor = "#ffffff";
				if (metaThemeColor) metaThemeColor.setAttribute("content", "#ffffff");
			}
			localStorage.setItem("neuquen-theme", theme);
		}
	}, [theme]);

	useEffect(() => {
		if (typeof window !== "undefined") {
			localStorage.setItem("neuquen-color-scheme", colorScheme);
		}
	}, [colorScheme]);

	const toggleTheme = () => {
		setTheme((prev) => (prev === "light" ? "dark" : "light"));
	};

	const colors = themeColors[theme];
	const scheme = colorSchemes[colorScheme][theme];

	const value = {
		theme,
		setTheme,
		colorScheme,
		setColorScheme,
		toggleTheme,
		colors,
		scheme,
	};

	return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error("useTheme must be used within a ThemeProvider");
	}
	return context;
};
